import { Formik, Form } from 'formik';
import { Link, useSearchParams } from 'react-router-dom';

import { Button, FormikInput } from '@febos-io/design';

import useTranslation from '../hooks/useTranslation';
import changePasswordSchema from '../schemas/changePasswordSchema';
import { useAuthContext } from '../providers';
import { useResetPassword } from '../hooks';

export function ChangePasswordForm() {
  const {
    signInPathname
  } = useAuthContext();
  const { t } = useTranslation();
  const {
    loading,
    onSubmit
  } = useResetPassword();
  const [searchParams] = useSearchParams();

  return (
    <>
      <br />
      <small className="my-1">{t('Enter your email and we will send you the instructions to obtain a new password')}</small>
      <Formik
        initialValues={{
          email: searchParams.get('email') || ''
        }}
        validationSchema={changePasswordSchema}
        onSubmit={onSubmit}
      >
        <Form>
          <FormikInput
            name="email"
            label={t('Email')}
            type="email"
            placeholder="user@example.com"
            icon="user"
            className="mt-1 mb-2"
          />
          <div className="d-grid">
            <Button
              type="submit"
              loading={loading}
            >
              {t('Send')}
            </Button>
          </div>
        </Form>
      </Formik>
      <br />
      <Link to={signInPathname}>
        <small>{t('Back to Login')}</small>
      </Link>
    </>
  );
}

export default ChangePasswordForm;
